export default __webpack_public_path__ + "assets/ogg/da566e22d8b2558b44eea4a1582084fe.ogg";